import {
    UPDATE_USER_PASSWORD_START,
    UPDATE_USER_PASSWORD_SUCCESS,
    UPDATE_USER_PASSWORD_ERROR,
    UPDATE_USER_PASSWORD_RESET,
    RESET_PWD_START,
    RESET_PWD_SUCCESS,
    RESET_PWD_ERROR,
    RESET_PWD_RESET
} from "../actions/auth";

const defaultState = {
    status: {
        started: false,
        error: false,
        ended: false,
        errorInfo: {
            code: "",
            message: ""
        }
    }
};

export function update(state = defaultState, { type, payload, error }) {
    switch (type) {
        case UPDATE_USER_PASSWORD_START:
            return {
                status: {
                    started: true,
                    error: false,
                    ended: false
                }
            };
        case UPDATE_USER_PASSWORD_SUCCESS:
            return {
                status: {
                    started: false,
                    error: false,
                    ended: true
                },
                ...payload
            };
        case UPDATE_USER_PASSWORD_ERROR:
            return {
                status: {
                    started: false,
                    error: true,
                    ended: false,
                    errorInfo: { code: error.code, message: error.message }
                }
            };
        case UPDATE_USER_PASSWORD_RESET:
            return {
                ...defaultState
            };
        default:
            return state;
    }
}

export function reset(state = defaultState, { type, payload, error }) {
    switch (type) {
        case RESET_PWD_START:
            return {
                status: {
                    started: true,
                    error: false,
                    ended: false
                }
            };
        case RESET_PWD_SUCCESS:
            return {
                status: {
                    started: false,
                    error: false,
                    ended: true
                },
                ...payload
            };
        case RESET_PWD_ERROR:
            return {
                status: {
                    started: false,
                    error: true,
                    ended: false,
                    errorInfo: { code: error.code, message: error.message }
                }
            };
        case RESET_PWD_RESET:
            return {
                ...defaultState
            };
        default:
            return state;
    }
}
